import script from "./dataField.vue?vue&type=script&setup=true&lang=ts"
export * from "./dataField.vue?vue&type=script&setup=true&lang=ts"

import "./dataField.vue?vue&type=style&index=0&id=c3b6db4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b6db4e"]])

export default __exports__